import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  class: "card-icon",
  style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)"}
}
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = {
  class: "card-icon",
  style: {"background":"linear-gradient(135deg, #f0a020 0%, #d97706 100%)"}
}
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = {
  class: "card-icon",
  style: {"background":"linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_grid_item = _resolveComponent("n-grid-item")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_statistic = _resolveComponent("n-statistic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_grid, {
      "x-gap": 20,
      "y-gap": 20,
      cols: _ctx.responsiveCols
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_grid_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_card, {
              hoverable: "",
              class: "project-card",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToProject('easyapis')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_n_icon, {
                      size: "48",
                      color: "white"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_n_h3, { style: {"margin":"16px 0 8px 0"} }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("EasyApis", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_text, {
                    depth: "3",
                    style: {"font-size":"14px","line-height":"1.6"}
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" 简单易用的 API 工具集合，提供各种实用的接口服务 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_divider, { style: {"margin":"16px 0"} }),
                  _createVNode(_component_n_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_tag, {
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("已启用", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_n_tag, {
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("v1.0.0", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_n_grid_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_card, {
              hoverable: "",
              class: "project-card",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToProject('textprocess')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_n_icon, {
                      size: "48",
                      color: "white"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M11 6h2v3h6v2H5V9h6V6zm-6 7h14v2H5v-2zm0 4h9v2H5v-2z"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_n_h3, { style: {"margin":"16px 0 8px 0"} }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("文本处理", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_text, {
                    depth: "3",
                    style: {"font-size":"14px","line-height":"1.6"}
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" 按自定义规则批量加工文本，规则可保存复用 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_divider, { style: {"margin":"16px 0"} }),
                  _createVNode(_component_n_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_tag, {
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("已启用", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_n_tag, {
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("v1.0.0", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_n_grid_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_card, {
              hoverable: "",
              class: "project-card placeholder-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_n_icon, {
                      size: "48",
                      color: "white"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_n_h3, { style: {"margin":"16px 0 8px 0"} }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("未来项目", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_text, {
                    depth: "3",
                    style: {"font-size":"14px","line-height":"1.6"}
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" 更多精彩内容敬请期待... ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_n_divider, { style: {"margin":"16px 0"} }),
                  _createVNode(_component_n_tag, {
                    type: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("即将推出", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["cols"]),
    _createVNode(_component_n_card, { style: {"margin-top":"40px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_n_space, { justify: "space-around" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_statistic, {
              label: "总项目数",
              value: "2"
            }),
            _createVNode(_component_n_statistic, {
              label: "已启用",
              value: "2"
            }),
            _createVNode(_component_n_statistic, {
              label: "开发中",
              value: "1"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}